
import React from 'react';
import { ChevronRight, Rocket, ShieldCheck, Star } from 'lucide-react';

const Hero: React.FC = () => {
  const scrollToForm = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative pt-32 pb-20 md:pt-48 md:pb-40 overflow-hidden bg-[#0F1419]">
      {/* Background Visual: Authentic Bucket Truck Image */}
      <div className="absolute inset-0 opacity-40 pointer-events-none">
        <img 
          src="https://storage.googleapis.com/msgsndr/RFigwwpXwgFKDDWbFLQd/media/695494cf035c3a5813fc8f24.jpg" 
          className="w-full h-full object-cover object-center grayscale brightness-[0.4]"
          alt="Tree Bucket Truck Work"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F1419] via-transparent to-[#0F1419]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="inline-flex items-center gap-3 bg-[#1A4D2E]/40 text-[#F4E4C1] border border-[#1A4D2E] px-6 py-2 rounded-full text-xs font-black mb-10 animate-in fade-in slide-in-from-top-4 duration-1000 uppercase tracking-widest backdrop-blur-md">
          <Rocket className="w-4 h-4 text-[#FF6B35]" />
          Built By A Tree Pro For Tree Pros
        </div>
        
        <h1 className="text-5xl md:text-8xl lg:text-9xl font-black leading-[0.85] mb-8 animate-in fade-in slide-in-from-bottom-4 duration-700 uppercase italic text-white tracking-tighter drop-shadow-2xl">
          Stop Chasing Leads. <br />
          Add <span className="text-[#FF6B35]">$20k+ Per Month</span> <br className="hidden md:block" />
          By Automating Sales.
        </h1>
        
        <p className="text-xl md:text-3xl text-gray-300 max-w-4xl mx-auto mb-12 leading-tight animate-in fade-in duration-1000 delay-300 font-bold italic">
          You’re out in the field running crews, not sitting behind a desk. We built the only system that captures leads, follows up automatically, and books jobs while you’re in the tree.
        </p>
        
        <div className="flex flex-col items-center gap-6 animate-in zoom-in duration-700 delay-500">
          <div className="flex flex-col items-center gap-4">
            <div className="relative group">
              <div className="absolute -inset-1 bg-[#FF6B35] rounded-2xl blur opacity-40 group-hover:opacity-70 transition duration-300"></div>
              <button 
                onClick={scrollToForm}
                className="relative bg-[#FF6B35] hover:bg-white hover:text-[#0F1419] text-2xl md:text-3xl font-black px-12 py-8 rounded-2xl transition-all shadow-2xl flex items-center gap-4 transform hover:scale-105 active:scale-95 uppercase tracking-tight text-white cursor-pointer"
              >
                START YOUR 14-DAY TRIAL
                <ChevronRight className="w-8 h-8 group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
            <p className="text-[#FF6B35] font-black uppercase text-sm tracking-widest animate-pulse">
              ONLY 7 SPOTS LEFT THIS MONTH
            </p>
          </div>
          
          <div className="flex flex-col items-center gap-4">
            <p className="text-[#F4E4C1] text-xs font-black uppercase tracking-[0.2em] opacity-80">
              Join 200+ Tree Pros scaling their crews today
            </p>
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#FF6B35] text-[#FF6B35]" />)}
              <span className="ml-2 text-white font-black uppercase text-[10px] tracking-widest">4.9/5 Rating</span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-[#6B7280] text-[10px] md:text-xs font-black uppercase tracking-[0.2em] mt-4">
            <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-[#1A4D2E]" /> WHITE GLOVE SETUP</span>
            <span className="w-1.5 h-1.5 bg-[#4E3629] rounded-full hidden md:block" />
            <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-[#1A4D2E]" /> WEEKLY COACHING</span>
            <span className="w-1.5 h-1.5 bg-[#4E3629] rounded-full hidden md:block" />
            <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-[#1A4D2E]" /> PROVEN SYSTEMS</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
